import React from 'react'

function Loader() {
  return (
    <div className="min-h-min min-w-min flex justify-center align-middle">
            <div className="border-t-transparent border-solid animate-spin rounded-full border-spicy border-8 h-32 w-32"></div>
    </div>
  )
}

export default Loader;